"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _mediaDetailContext = require("./media-detail-context");

var _MediaDetailHeader = _interopRequireDefault(require("./MediaDetailHeader"));

var _media = require("../../util/media");

var _qa = _interopRequireDefault(require("../../util/qa"));

var _MediaDetailDashboard = _interopRequireDefault(require("./MediaDetailDashboard"));

var _Toolbar = _interopRequireDefault(require("./Toolbar"));

var _MediaSphereViewer = _interopRequireDefault(require("./MediaSphere/MediaSphereViewer"));

var _Photo = _interopRequireDefault(require("./Photo"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Container = _styledComponents.default.div`
  position: absolute;
  top: 0;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  background: ${_alloyReactTheme.default.colors.white};
  overflow: hidden;
`;
const StyledPhoto = _styledComponents.default.div`
  position: relative;
  height: ${props => props.fullscreen ? "100%" : "calc(100% - 70px)"};
  width: ${props => props.fullscreen ? "100%" : "calc(100% - 380px)"};
  background: ${props => props.fullscreen ? _alloyReactTheme.default.colors.black : _alloyReactTheme.default.colors.charcoal100};
`;
const StyledHeader = _styledComponents.default.div`
  width: 100%;
  ${props => props.fullscreen && "display: none;"}
`;
const StyledDashboard = _styledComponents.default.div`
  overflow-y: scroll;
  overflow-x: hidden;
  width: 380px;
  height: calc(100% - 70px);
  display: ${props => props.fullscreen ? "none" : "block"};
`;
const StyledVideo = _styledComponents.default.video`
  width: 100%;
  height: 100%;
`;
const StyledMediaSphereViewer = (0, _styledComponents.default)(_MediaSphereViewer.default)`
  width: 100%;
  height: 100%;
`;

const MediaDetailModal = () => {
  const {
    state: {
      media
    },
    mediaHandlers
  } = (0, _mediaDetailContext.useMedia)();
  const [fullscreen, setFullscreen] = (0, _react.useState)(false);
  const videoEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (videoEl && videoEl.current && mediaHandlers.playHandler) {
      const handlePlay = e => mediaHandlers.playHandler(media, e);

      videoEl.current.addEventListener("play", handlePlay);
      return videoEl.current.removeEventListener("play", handlePlay);
    }
  }, [videoEl, mediaHandlers, media]); // enable close fullscreen on esc

  (0, _react.useEffect)(() => {
    if (fullscreen) {
      const closeOnEsc = e => {
        if (e.key === "Escape" || e.key === "Esc") {
          setFullscreen(false);
        }
      };

      window.addEventListener("keydown", closeOnEsc);
      return () => window.removeEventListener("keydown", closeOnEsc);
    }
  });
  const renderMedia = (0, _react.useCallback)(() => {
    switch (media.imageType) {
      case _media.IMAGE_TYPES.VIDEO:
        return /*#__PURE__*/_react.default.createElement(StyledVideo, {
          ref: videoEl,
          "data-qa": _qa.default.media,
          controls: true,
          key: media.fullUrl
        }, /*#__PURE__*/_react.default.createElement("source", {
          src: media.fullUrl,
          type: "video/mp4"
        }));

      case _media.IMAGE_TYPES.PHOTOSPHERE:
        return /*#__PURE__*/_react.default.createElement(StyledMediaSphereViewer, {
          media: media
        });

      default:
        return /*#__PURE__*/_react.default.createElement(_Photo.default, {
          src: media.fullUrl
        });
    }
  }, [media]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-qa": _qa.default.mediaDetailModal,
    fullscreen: fullscreen
  }, /*#__PURE__*/_react.default.createElement(StyledHeader, {
    fullscreen: fullscreen
  }, /*#__PURE__*/_react.default.createElement(_MediaDetailHeader.default, null)), /*#__PURE__*/_react.default.createElement(StyledPhoto, {
    fullscreen: fullscreen
  }, renderMedia(), /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    fullscreen: fullscreen,
    setFullscreen: () => {
      mediaHandlers.fullscreenHandler && mediaHandlers.fullscreenHandler(!fullscreen);
      setFullscreen(!fullscreen);
    }
  })), /*#__PURE__*/_react.default.createElement(StyledDashboard, {
    fullscreen: fullscreen
  }, /*#__PURE__*/_react.default.createElement(_MediaDetailDashboard.default, null)));
};

var _default = MediaDetailModal;
exports.default = _default;